const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const accountClassForSubject = subjectType => ({
  property: 'property_tax',
  business: 'business_tax',
  service_connection: 'service_charge',
}[subjectType] || '');

export const taxAccountCreatePayload = values => {
  const subjectType = String(values?.subject_type || '').trim();
  const subjectUid = String(values?.subject_uid || '').trim().toLowerCase();
  const accountClass = String(values?.account_class || '').trim();
  if (!accountClassForSubject(subjectType)) throw new Error('वैध करपात्र नोंद प्रकार निवडा.');
  if (!UUID_PATTERN.test(subjectUid)) throw new Error('स्थिर UID असलेली वैध नोंद निवडा.');
  if (accountClass !== accountClassForSubject(subjectType)) {
    throw new Error('कर खाते प्रकार निवडलेल्या नोंद प्रकाराशी जुळत नाही.');
  }
  return {
    subject_type: subjectType,
    subject_uid: subjectUid,
    account_class: accountClass,
    account_number: String(values?.account_number || '').trim() || undefined,
    metadata: { office_note: String(values?.office_note || '').trim() || undefined },
    reason: String(values?.reason || '').trim(),
  };
};

export const registrySubjectLabel = (type, item) => {
  if (type === 'business') {
    return [item?.business_name || item?.legal_name || 'व्यवसाय', item?.business_category || item?.business_type]
      .filter(Boolean).join(' · ');
  }
  if (type === 'service_connection') {
    return [item?.connection_number || 'सेवा जोडणी', item?.service_type, item?.tariff_class]
      .filter(Boolean).join(' · ');
  }
  return [
    item?.property_name || 'मालमत्ता',
    item?.assessment_number,
    [item?.address_line_1, item?.locality, item?.ward_number ? `प्रभाग ${item.ward_number}` : ''].filter(Boolean).join(', '),
  ].filter(Boolean).join(' · ');
};

export const registrySubjectUid = (type, item) => ({
  business: item?.business_uid,
  property: item?.property_uid,
  service_connection: item?.connection_uid,
}[type] || '');

export const accountSubjectDisplay = account => ({
  name: account?.subject?.name || 'करपात्र नोंद',
  uid: account?.subject?.uid || 'स्थिर नोंद UID उपलब्ध नाही',
  detail: account?.subject?.address || account?.subject?.category || account?.subject_type?.replaceAll('_', ' ') || '',
});
